__turbopack_context__.v({
  "container": "hcduwG_container",
  "description": "hcduwG_description",
  "nudges": "hcduwG_nudges",
  "productDetails": "hcduwG_productDetails",
  "productImage": "hcduwG_productImage",
  "productPlaceholder": "hcduwG_productPlaceholder",
  "shippingPriceCaption": "hcduwG_shippingPriceCaption",
  "text": "hcduwG_text",
});
